function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

var contactMap = document.getElementById("my_map");

if (contactMap) {
  var propertyMap =
    propertyMap ||
    (function () {
      //private variables
      var lat, lng, latLng, map, directionsService, directionsDisplay, panorama; //, directionDistance;

      return {
        //
        //Sets the latitude & longitude of the section of the map we want to pin point (must be called first)
        latLng: function (_lat, _lng) {
          lat = _lat;
          lng = _lng;
        },

        //
        //Function to render the map to screen
        render: function () {
          if (!isNumber(lat) || !isNumber(lng)) {
            //lat or long is invalid, exit.
            return;
          }

          latLng = new google.maps.LatLng(lat, lng);

          //Setup the map options
          var mapOptions = {
            center: latLng,
            zoom: 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            mapTypeControlOptions: {
              style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
              position: google.maps.ControlPosition.LEFT_BOTTOM,
            },
          };

          //Set the map div
          map = new google.maps.Map(
            document.getElementById("my_map"),
            mapOptions
          );

          /*var markerImage = {
					url: "images/pin-home.png",
					anchor: new google.maps.Point(13,38)
				};
				
				var markerShadow = {
					url: "images/pin-shadow.png",
					anchor: new google.maps.Point(6,30)
				}*/

          //Map marker options
          var marker = new google.maps.Marker({
            position: latLng,
            //'icon': markerImage,
            //'shadow': markerShadow,
            map: map,
            animation: google.maps.Animation.DROP,
            optimized: true,
            title: "Sirius Project Engineering",
            content: "",
          });

          //Attach the various controls for the map sytsem...

          //Map enlargement/ reduction
          $("#enlargeMap").click(function (e) {
            e.preventDefault();

            //Move the current map to the popup holder
            $("#mapAndOptions").appendTo($("#map_holder_popup"));

            //Popup code
            $.magnificPopup.open({
              items: {
                src: "#map_holder_popup",
                type: "inline",
              },
              callbacks: {
                open: function () {
                  //Save the original width and height for later
                  origWidth = $("#my_map").width();
                  origHeight = $("#my_map").height();

                  $("#my_map").width("100%");
                  $("#my_map").height($(window).height() * 0.7);
                  propertyMap.resize();
                },
                close: function () {
                  //Return the map to it's previous position
                  $("#mapAndOptions").prependTo($("#map_holder"));
                  //And resize it...
                  $("#my_map").width(origWidth);
                  $("#my_map").height(origHeight);
                  propertyMap.resize();
                },
              },
            });

            propertyMap.resize();
          });

          //Directions code
          function renderDirections() {
            var sourceLocation = $("#directionsSource").val();
            propertyMap.directions(sourceLocation);
            $("#clearDirections").fadeIn();
            switchView("Map view");

            //Show the driving directions and resize the height to match the map
            $("#driving_directions").addClass("show_driving_directions");

            //Add margin to the map a,d call the resize function -- to make room for written directions
            $("#my_map").addClass("mapMargin");
            propertyMap.resize();

            //alert(propertyMap.drivingDistance());
          }

          $("#directionsSource").keydown(function (e) {
            if (e.which == 13) renderDirections();
          });
          $("#goDirections").click(function (e) {
            renderDirections();
          });

          $("#clearDirections").click(function (e) {
            $("#directionsSource").val("");
            propertyMap.clearDirections();
            $("#clearDirections").fadeOut();

            //Remove the driving directions panel and resize/ re-center the map
            $("#driving_directions").removeClass("show_driving_directions");
            $("#my_map").removeClass("mapMargin");
            propertyMap.resize();
          });

          //View switcher
          $("#switchView").click(function (e) {
            var buttonText = $(this).text();
            switchView($(this).text());
          });

          function switchView(buttonText) {
            if (buttonText == "Street view") {
              //Display street view
              propertyMap.streetView();
              buttonText = "Map view";
            } else {
              //Display map view
              propertyMap.mapView();
              buttonText = "Street view";
            }
            $("#switchView").text(buttonText);
          }

          //End of controls for map system
        },

        //
        //Trigger the gmap resize function and recenter the map position
        resize: function () {
          //Resize and re-center the map
          google.maps.event.trigger(map, "resize");
          map.setCenter(latLng);

          //Resize the directions panel
          $("#driving_directions").css("height", $("#my_map").height());

          return;
        },

        //
        //Create an instance of the directions service (if it doesn't already exist)
        //and calculate directions from inputted source to latlng destination
        directions: function (sourceLocation) {
          if (typeof directionsService === "undefined") {
            directionsService = new google.maps.DirectionsService();
            directionsDisplay = new google.maps.DirectionsRenderer();
          }
          directionsDisplay.setMap(map);
          directionsDisplay.setPanel(
            document.getElementById("driving_directions")
          );

          var request = {
            origin: sourceLocation,
            destination: latLng,
            travelMode: google.maps.DirectionsTravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.IMPERIAL,
          };

          directionsService.route(request, function (response, status) {
            //directionDistance = ""; //Reset distance
            if (status == google.maps.DirectionsStatus.OK) {
              directionsDisplay.setDirections(response);
              if (typeof panorama != "undefined") panorama.setVisible(false); //Revert to map view

              //Now we can grab the distance between the points
              var directionDistance = response.routes[0].legs[0].distance.text; //"xx mi" //What do we do with this?
              $("#driving_distance")
                .text(directionDistance + " to destination")
                .addClass("animated flipInX")
                .show();
            } else {
              alert(
                "We could not find your location.\nTry being more specified, like entering your postcode."
              );
            }
          });
        },

        //
        //Clear the driving directions from the map
        clearDirections: function () {
          if (typeof directionsService != "undefined") {
            directionsDisplay.setMap(null);
            $("#driving_distance").hide(); //.addClass("animated flipOutX");
            map.setCenter(latLng);
          }
          return true;
        },

        //
        //Switch over to streetview
        streetView: function () {
          //Return the nearest street view in a given radius of 100 meters from latLng
          var sv = new google.maps.StreetViewService();
          sv.getPanoramaByLocation(latLng, 100, processSVData);

          //Called when we receive streetview data from Google
          function processSVData(data, status) {
            if (status == google.maps.StreetViewStatus.OK) {
              panorama = map.getStreetView();
              panorama.setPosition(data.location.latLng);

              //Compute heading, so that we're pointing TOWARDS the map point
              var heading = google.maps.geometry.spherical.computeHeading(
                data.location.latLng,
                latLng
              );
              panorama.setPov({ heading: heading, pitch: 0 });
              panorama.setVisible(true);
            } else {
              alert("Street view data not found for this location.");
            }
          }
        },

        //
        //Switch back to map view
        mapView: function () {
          if (typeof panorama != "undefined") panorama.setVisible(false);
        },

        //
        //Return driving distance from directions (if they exist)
        drivingDistance: function () {
          return directionDistance;
        },
      };
    })();

  $(document).ready(function () {
    propertyMap.latLng("52.289217", "-1.910191");
    propertyMap.render();
  });
}
